import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import ChangePasswordForm, { IPasswordForm } from "@src/Components/Common/ChangePasswordForm/ChangePasswordForm";
import { Grid } from "@material-ui/core";
import { IManagementStore } from "@src/Stores/Management/types";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import { Values } from "@src/Tools/Values";
import { Person } from "@src/Interfaces/Entity/Person";
import ResetUserPassword from "./ResetUserPassword/ResetUserPassword";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  person: Person;
}

@inject("management")
@observer
export default class PersonChangePassword extends React.Component<IProps> {
  @observable modalOpened: boolean = false;

  handleOpen = () => {
    this.modalOpened = true;
  };
  handleClose = () => {
    this.modalOpened = false;
  };

  handleUpdatePassword = async (values: IPasswordForm) => {
    await this.props.management.changePassword(this.props.person.id, values.password);
    this.modalOpened = false;
  };

  render() {
    return (
      <React.Fragment>
        <RoundButton
            icon={<VpnKeyIcon/>}
            tooltipTitle={Values.getLocalizationValue("changePassword")}
            onClick={() => this.handleOpen()}
        />
        
        <SimpleModal width={600} isOpened={this.modalOpened} onClose={this.handleClose}>
          <ChangePasswordForm
            title={Values.getLocalizationValue("createNewPassword")}
            personName={this.props.person.fullName}
            onSubmit={this.handleUpdatePassword}
          >
            <Grid container justify="flex-end">
              <STButtonMargin
                onClick={this.handleClose}
                variant="contained"
                style={{ textTransform: "none", marginRight: "auto" }}
              >
                {Values.getLocalizationValue("cancel")}
              </STButtonMargin>
              <ResetUserPassword person={this.props.person} />
              <STButtonMargin
                type="submit"
                variant="contained"
                color="primary"
                style={{ textTransform: "none", backgroundColor: "green" }}
              >
                {Values.getLocalizationValue("saveNewPassword")}
              </STButtonMargin>
            </Grid>
          </ChangePasswordForm>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
